import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: '20px',
    minHeight: '178px',
    border: '1px solid #ddd',
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  }
}));
export default (props) => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper} elevation={0} >
    </Paper>
  );
}
